import {Button} from './Button';

export const components = {
  Button,
};
